import { CommonErrorType } from '../../../types'
import { APIErrorType, ErrorRow } from '../types/errorTypes'

export const isAPIErrorType = (
  error: CommonErrorType
): error is APIErrorType => {
  return (error as APIErrorType).response !== undefined
}

const getErrorOutput = (errors: ErrorRow[]) => {
  return errors[0].output
}

export const parseErrorOutput = (error: APIErrorType) => {
  return getErrorOutput(error.response.data.errors)
}

export const parseErrorMessage = (error: APIErrorType) => {
  return parseErrorOutput(error).payload.message || ''
}
